import { useTranslation } from 'react-i18next';
import { ArticlePage, type ArticlePageData, type ArticleBodyBlock } from '@/components/article';

type ParagraphSectionKey = 'aquagrip' | 'trueform' | 'multiBand' | 'manufacturing';

export default function Technology() {
  const { t } = useTranslation();

  const buildParagraphSection = (key: ParagraphSectionKey) => ({
    number: t(`technology.sections.${key}.number`),
    title: t(`technology.sections.${key}.title`),
    subtitle: t(`technology.sections.${key}.subtitle`),
    keyOutcomes: t(`technology.sections.${key}.outcomes`, { returnObjects: true }) as string[],
    body: (t(`technology.sections.${key}.body`, { returnObjects: true }) as string[]).map(
      (text) => ({ type: 'paragraph' as const, text }),
    ),
  });

  // Tri-Channel section is special: intro paragraphs + three channel emphasis
  // lines + outro paragraph. We assemble the body block here.
  const triBody: ArticleBodyBlock[] = [
    { type: 'paragraph', text: t('technology.sections.triChannel.intro1') },
    { type: 'paragraph', text: t('technology.sections.triChannel.intro2') },
    {
      type: 'channel',
      label: t('technology.sections.triChannel.channel1.label'),
      text: t('technology.sections.triChannel.channel1.text'),
    },
    {
      type: 'channel',
      label: t('technology.sections.triChannel.channel2.label'),
      text: t('technology.sections.triChannel.channel2.text'),
    },
    {
      type: 'channel',
      label: t('technology.sections.triChannel.channel3.label'),
      text: t('technology.sections.triChannel.channel3.text'),
    },
    { type: 'paragraph', text: t('technology.sections.triChannel.outro') },
  ];

  const triSection = {
    number: t('technology.sections.triChannel.number'),
    title: t('technology.sections.triChannel.title'),
    subtitle: t('technology.sections.triChannel.subtitle'),
    keyOutcomes: t('technology.sections.triChannel.outcomes', {
      returnObjects: true,
    }) as string[],
    body: triBody,
  };

  const data: ArticlePageData = {
    pageTitle: t('technology.title'),
    intro: t('technology.intro'),
    sections: [
      buildParagraphSection('aquagrip'),
      buildParagraphSection('trueform'),
      buildParagraphSection('multiBand'),
      triSection,
      buildParagraphSection('manufacturing'),
    ],
    disclaimer: t('technology.disclaimer'),
  };

  return (
    <ArticlePage
      data={data}
      seo={{
        title: t('technology.pageHeader'),
        description: t('technology.meta.description'),
        path: '/technology',
      }}
    />
  );
}
